import { Routes } from '@angular/router';
import {
  ALLPROFILES,
  CALCULATOR_PROFIT_ROUTE,
  CALCULATOR_ROUTE,
  CAMPAIGN_AGREEMENT_ROUTE,
  CAMPAIGN_OTP_ROUTE,
  CAMPAIGN_SHAHKAR_ERROR_ROUTE,
  CASHIN_ROUTE,
  CASHOUT_ROUTE,
  CHANGE_PHONE_NUMBER_ROUTE,
  CHOICE_PAYMENT_METHOD_ROUTE,
  COLLATERAL_APPROVED_ROUTE,
  COLLATERAL_REJECTED_ROUTE,
  COLLATERAL_ROUTE,
  COLLATERAL_WAITING_ROUTE,
  CONFIRM_COLLATERAL_INFO_ROUTE,
  CREATE_PASSWORD_ROUTE,
  CROWD_LIST_ROUTE,
  EXPIRED_NOTICE_ROUTE,
  EXPIRED_PASSWORD_ROUTE,
  EXPIRED_SESSION_NOTICE_ROUTE,
  FAQ,
  FORGET_PASSWORD_ROUTE,
  GENERAL_ERROR_ROUTE,
  HOME_ROUTE,
  HOME_TAB_ROUTE,
  INVESTMENT_LIST_ROUTE,
  IPG_CALLBACK_ROUTE,
  IPO_ROUTE,
  LOGIN_ROUTE,
  NATIONAL_ID_ERROR_ROUTE,
  NATIONAL_ID_ROUTE,
  News,
  OFF_TIME_ERROR_ROUTE,
  OTP_ROUTE,
  PAYMENT_METHOD_CONDITIONS_ROUTE,
  PENDING_TRANSACTIONS_ROUTE,
  PORTFO,
  PRICES,
  PROFILE_ROUTE,
  PROSPECTUS_ROUTE,
  PROVIDER_CAPACITY_FULL_ROUTE,
  PROVIDER_NOT_AVAILABLE_ROUTE,
  PURCHASE_ROUTE,
  RECEIPT_ROUTE,
  REGISTER_ROUTE,
  RESULT_ROUTE,
  SEJAM_CHECK_ROUTE,
  SEJAM_ERROR_ROUTE,
  SEJAM_NATIONAL_ID_ROUTE,
  SEJAM_SUCCESS_ROUTE,
  SELL_DETAIL_ROUTE,
  SELL_OTP_ROUTE,
  SELL_ROUTE,
  SELL_STOCK_ROUTE,
  SIGN_AGREEMENTS_ROUTE,
  SOON,
  TRANSACTIONS_ROUTE,
  TREASURE_HUNT_CAPACITY_FULL_ROUTE,
  TREASURE_HUNT_NATIONAL_ID_ROUTE,
  TREASURE_HUNT_REGISTRATION_SUCCESSFUL_ROUTE,
  TREASURE_HUNT_START_ROUTE,
  TREASURE_HUNT_SUCCESSFUL_ROUTE,
  UNAUTHORIZED_ROUTE,
  USER_EXIST_WITH_ANOTHER_PHONE_NUMBER_ROUTE,
  USER_LOGIN_ACTIVITIES_ROUTE,
  WALLET_BNPL_CANCEL_RESULT_ROUTE,
  WALLET_BNPL_DETAIL_ROUTE,
  WALLET_BNPL_ROUTE,
  WALLET_CASH_IN_INDISTINCTIVE_ROUTE,
  WALLET_CASH_IN_ROUTE,
  WALLET_CASH_OUT_ROUTE,
  WALLET_CUTOFF_ROUTE,
  WALLET_IBAN_ROUTE,
  WALLETS_ROUTE,
} from './data-access/constants/app-routes';
import { LoginComponent } from './features/makna-authentication/containers/login/login.component';
import { AuthenticationGuard } from './components/core/guards/authentication.guard';
import { StagingGuard } from './components/core/guards/staging.guard';

export const wealthRoutes: Routes = [
  {
    path: REGISTER_ROUTE,
    loadComponent: () => import('./features/makna-authentication/containers/register/register.component').then((c) => c.RegisterComponent),
  },
  {
    path: LOGIN_ROUTE,
    component: LoginComponent,
  },
  {
    path: FORGET_PASSWORD_ROUTE,
    loadComponent: () =>
      import('./features/makna-authentication/containers/forget-password/forget-password.component').then((c) => c.ForgetPasswordComponent),
  },
  {
    path: CHANGE_PHONE_NUMBER_ROUTE,
    loadComponent: () =>
      import('./features/makna-authentication/containers/change-phone-number/change-phone-number.component').then(
        (c) => c.ChangePhoneNumberComponent,
      ),
  },
  {
    path: EXPIRED_NOTICE_ROUTE,
    loadComponent: () =>
      import('./features/makna-authentication/containers/expired-notice/expired-notice.component').then((c) => c.ExpiredNoticeComponent),
  },
  {
    path: EXPIRED_PASSWORD_ROUTE,
    loadComponent: () =>
      import('./features/makna-authentication/containers/expired-password/expired-password.component').then(
        (c) => c.ExpiredPasswordComponent,
      ),
  },
  {
    path: EXPIRED_SESSION_NOTICE_ROUTE,
    loadComponent: () =>
      import('./features/makna-authentication/containers/session-expired-notice/session-expired-notice.component').then(
        (c) => c.SessionExpiredNoticeComponent,
      ),
  },
  {
    path: IPG_CALLBACK_ROUTE,
    loadComponent: () => import('./features/purchase/containers/ipg-callback/ipg-callback.component').then((c) => c.IpgCallbackComponent),
  },
  {
    path: '',
    // canActivate: [LandingPageGuard],
    loadComponent: () => import('./features/landing/containers/landing/landing.component').then((c) => c.LandingComponent),
  },
  {
    path: '',
    canActivate: [AuthenticationGuard],
    children: [
      {
        path: PURCHASE_ROUTE,
        children: [
          {
            path: ':id',
            loadComponent: () => import('./features/purchase/containers/purchase/purchase.component').then((c) => c.PurchaseComponent),
          },
        ],
      },
      {
        path: SIGN_AGREEMENTS_ROUTE,
        loadComponent: () =>
          import('./features/purchase/containers/sign-agreement/sign-agreements.component').then((c) => c.SignAgreementsComponent),
      },
      {
        path: SELL_ROUTE,
        children: [
          {
            path: ':id',
            loadComponent: () => import('./features/purchase/containers/sell/sell.component').then((c) => c.SellComponent),
          },
        ],
      },
      {
        path: TRANSACTIONS_ROUTE,
        loadComponent: () =>
          import('./features/transaction/containers/transactions/transactions.component').then((c) => c.TransactionsComponent),
        data: { title: 'TRANSACTIONS' },
      },
      {
        path: PENDING_TRANSACTIONS_ROUTE,
        loadComponent: () =>
          import('./features/transaction/containers/pending-transactions/pending-transactions.component').then(
            (c) => c.PendingTransactionsComponent,
          ),
        data: { title: 'TRANSACTIONS' },
      },
      {
        path: TREASURE_HUNT_START_ROUTE,
        loadComponent: () =>
          import('./features/campaign/containers/campaign-start/campaign-start.component').then((c) => c.CampaignStartComponent),
      },
      {
        path: TREASURE_HUNT_CAPACITY_FULL_ROUTE,
        loadComponent: () =>
          import('./features/campaign/containers/campaign-capacity-full/campaign-capacity-full.component').then(
            (c) => c.CampaignCapacityFullComponent,
          ),
      },
      {
        path: TREASURE_HUNT_REGISTRATION_SUCCESSFUL_ROUTE,
        loadComponent: () =>
          import('./features/campaign/containers/campaign-registration-successful/campaign-registration-successful.component').then(
            (c) => c.CampaignRegistrationSuccessfulComponent,
          ),
      },
      {
        path: TREASURE_HUNT_SUCCESSFUL_ROUTE,
        loadComponent: () =>
          import('./features/campaign/containers/campaign-successful/campaign-successful.component').then(
            (c) => c.CampaignSuccessfulComponent,
          ),
      },
      {
        path: TREASURE_HUNT_NATIONAL_ID_ROUTE,
        loadComponent: () =>
          import('./features/campaign/containers/campaign-national-id/campaign-national-id.component').then(
            (c) => c.CampaignNationalIdComponent,
          ),
      },
      {
        path: CAMPAIGN_OTP_ROUTE,
        loadComponent: () =>
          import('./features/campaign/containers/campaign-otp/campaign-otp.component').then((c) => c.CampaignOtpComponent),
      },
      {
        path: CAMPAIGN_AGREEMENT_ROUTE,
        loadComponent: () =>
          import('./features/campaign/containers/campaign-agreements/campaign-agreements.component').then(
            (c) => c.CampaignAgreementsComponent,
          ),
      },
      {
        path: CAMPAIGN_SHAHKAR_ERROR_ROUTE,
        loadComponent: () =>
          import('./features/campaign/containers/campaign-shahkar-error/campaign-shahkar-error.component').then(
            (c) => c.CampaignShahkarErrorComponent,
          ),
      },
      {
        path: SEJAM_ERROR_ROUTE,
        loadComponent: () => import('./shared/containers/sejam-error/sejam-error.component').then((c) => c.SejamErrorComponent),
      },
      {
        path: NATIONAL_ID_ERROR_ROUTE,
        loadComponent: () =>
          import('./shared/containers/national-id-error/national-id-error.component').then((c) => c.NationalIdErrorComponent),
      },
      {
        path: SEJAM_CHECK_ROUTE,
        loadComponent: () =>
          import('./features/sejam-check/containers/sejam-check/sejam-check.component').then((c) => c.SejamCheckComponent),
      },
      {
        path: CALCULATOR_ROUTE,
        loadComponent: () => import('./features/calculator/containers/calculator/calculator.component').then((c) => c.CalculatorComponent),
      },
      {
        path: CALCULATOR_PROFIT_ROUTE,
        loadComponent: () =>
          import('./features/calculator/containers/calculator-profit/calculator-profit.component').then((c) => c.CalculatorProfitComponent),
      },
      {
        path: OTP_ROUTE,
        loadComponent: () => import('./features/purchase/containers/otp/otp.component').then((c) => c.OtpComponent),
      },
      {
        path: NATIONAL_ID_ROUTE,
        loadComponent: () => import('./features/purchase/containers/national-id/national-id.component').then((c) => c.NationalIdComponent),
      },
      {
        path: SELL_DETAIL_ROUTE,
        loadComponent: () => import('./features/purchase/containers/sell-detail/sell-detail.component').then((c) => c.SellDetailComponent),
      },
      {
        path: PROSPECTUS_ROUTE,
        loadComponent: () => import('./features/purchase/containers/prospectus/prospectus.component').then((c) => c.ProspectusComponent),
      },
      {
        path: RESULT_ROUTE,
        loadComponent: () =>
          import('./shared/containers/operation-result/operation-result.component').then((c) => c.OperationResultComponent),
      },
      {
        path: SELL_OTP_ROUTE,
        loadComponent: () => import('./features/purchase/containers/sell-otp/sell-otp.component').then((c) => c.SellOtpComponent),
      },
      {
        path: PROVIDER_NOT_AVAILABLE_ROUTE,
        loadComponent: () =>
          import('./shared/containers/provider-not-available/provider-not-available.component').then(
            (c) => c.ProviderNotAvailableComponent,
          ),
      },
      {
        path: PROVIDER_CAPACITY_FULL_ROUTE,
        loadComponent: () =>
          import('./shared/containers/provider-capacity-full/provider-capacity-full.component').then(
            (c) => c.ProviderCapacityFullComponent,
          ),
      },
      {
        path: OFF_TIME_ERROR_ROUTE,
        loadComponent: () => import('./shared/containers/off-time-error/off-time-error.component').then((c) => c.OffTimeErrorComponent),
      },
      {
        path: GENERAL_ERROR_ROUTE,
        loadComponent: () => import('./shared/containers/general-errors/general-errors.component').then((c) => c.GeneralErrorsComponent),
      },
      {
        path: RECEIPT_ROUTE,
        loadComponent: () => import('./shared/containers/receipt/receipt.component').then((c) => c.ReceiptComponent),
      },
      {
        path: PROFILE_ROUTE,
        loadComponent: () => import('./features/user-profile/user-profile.component').then((c) => c.UserProfileComponent),
      },
      {
        path: UNAUTHORIZED_ROUTE,
        loadComponent: () => import('./shared/containers/unauthorized/unauthorized.component').then((c) => c.UnauthorizedComponent),
      },
      {
        path: USER_LOGIN_ACTIVITIES_ROUTE,
        loadComponent: () =>
          import('./features/user-login-activities/user-login-activities.component').then((c) => c.UserLoginActivitiesComponent),
      },
      {
        path: SEJAM_NATIONAL_ID_ROUTE,
        loadComponent: () =>
          import('./features/sejam-check/containers/sejam-national-id/sejam-national-id.component').then((c) => c.SejamNationalIdComponent),
      },
      {
        path: SEJAM_SUCCESS_ROUTE,
        loadComponent: () =>
          import('./features/sejam-check/containers/sejam-successful/sejam-successful.component').then((c) => c.SejamSuccessfulComponent),
      },
      {
        path: INVESTMENT_LIST_ROUTE,
        children: [
          {
            path: ':id',
            loadComponent: () => import('./features/funds/fund-profile/fund-profile.component').then((c) => c.FundProfileComponent),
          },
          {
            path: '',
            loadComponent: () => import('./features/funds/funds-list/funds-list.component').then((c) => c.FundsListComponent),
          },
        ],
      },
      {
        path: USER_EXIST_WITH_ANOTHER_PHONE_NUMBER_ROUTE,
        loadComponent: () =>
          import('./features/purchase/components/user-exist-with-another-phone-number/user-exist-with-another-phone-number.component').then(
            (c) => c.UserExistWithAnotherPhoneNumberComponent,
          ),
      },
      {
        path: COLLATERAL_ROUTE + '/:symbol',
        loadComponent: () => import('./features/collateral/collateral.component').then((c) => c.CollateralComponent),
      },
      {
        path: CONFIRM_COLLATERAL_INFO_ROUTE,
        loadComponent: () =>
          import('./features/collateral/containers/confirm-collateral-info/confirm-collateral-info.component').then(
            (c) => c.ConfirmCollateralInfoComponent,
          ),
      },
      {
        path: COLLATERAL_WAITING_ROUTE,
        loadComponent: () =>
          import('./features/collateral/containers/collateral-waiting-result/collateral-waiting-result.component').then(
            (c) => c.CollateralWaitingResultComponent,
          ),
      },
      {
        path: COLLATERAL_REJECTED_ROUTE,
        loadComponent: () =>
          import('./features/collateral/containers/collateral-rejected-result/collateral-rejected-result.component').then(
            (c) => c.CollateralRejectedResultComponent,
          ),
      },
      {
        path: COLLATERAL_APPROVED_ROUTE,
        loadComponent: () =>
          import('./features/collateral/containers/collateral-approved-result/collateral-approved-result.component').then(
            (c) => c.CollateralApprovedResultComponent,
          ),
      },
      {
        path: WALLETS_ROUTE,
        children: [
          {
            path: ':id',
            loadComponent: () => import('./features/wallet/wallet.component').then((c) => c.WalletComponent),
          },
        ],
      },
      {
        path: WALLET_CASH_IN_ROUTE + '/:id',
        loadComponent: () =>
          import('./features/wallet/containers/wallet-cash-in/wallet-cash-in.component').then((c) => c.WalletCashInComponent),
      },
      {
        path: WALLET_CASH_OUT_ROUTE + '/:id',
        loadComponent: () =>
          import('./features/wallet/containers/wallet-cashout/wallet-cashout.component').then((c) => c.WalletCashoutComponent),
      },
      {
        path: WALLET_IBAN_ROUTE + '/:id',
        loadComponent: () => import('./features/wallet/containers/wallet-iban/wallet-iban.component').then((c) => c.WalletIbanComponent),
      },
      {
        path: WALLET_BNPL_ROUTE + '/:id',
        loadComponent: () => import('./features/wallet/containers/wallet-bnpl/wallet-bnpl.component').then((c) => c.WalletBnplComponent),
      },
      {
        path: WALLET_BNPL_DETAIL_ROUTE + '/:id',
        loadComponent: () =>
          import('./features/wallet/containers/wallet-bnpl-detail/wallet-bnpl-detail.component').then((c) => c.WalletBnplDetailComponent),
      },
      {
        path: WALLET_BNPL_CANCEL_RESULT_ROUTE,
        loadComponent: () =>
          import('./features/wallet/containers/wallet-bnpl-cancel-result/wallet-bnpl-cancel-result.component').then(
            (c) => c.WalletBnplCancelResultComponent,
          ),
      },
      {
        path: WALLET_CUTOFF_ROUTE + '/:id',
        loadComponent: () =>
          import('./features/wallet/containers/wallet-cutoff/wallet-cutoff.component').then((c) => c.WalletCutoffComponent),
      },
      {
        path: CREATE_PASSWORD_ROUTE,
        loadComponent: () =>
          import('./features/makna-authentication/containers/add-password/add-password.component').then((c) => c.AddPasswordComponent),
      },
      {
        path: FAQ,
        loadComponent: () => import('./features/faq/containers/faq/faq.component').then((c) => c.FaqComponent),
      },
      {
        path: News,
        loadComponent: () => import('./features/news/containers/news/news.component').then((c) => c.NewsComponent),
      },
      {
        path: PRICES,
        loadComponent: () => import('./features/price/containers/prices/prices.component').then((c) => c.PricesComponent),
      },
      {
        path: SOON,
        loadComponent: () => import('./features/coming-soon/coming-soon/coming-soon.component').then((c) => c.ComingSoonComponent),
      },
      {
        path: PORTFO,
        loadComponent: () => import('./features/portfo/container/portfo/portfo.component').then((c) => c.PortfoComponent),
      },
      {
        path: ALLPROFILES,
        loadComponent: () =>
          import('./features/portfo/components/portfo-all-profiles/portfo-all-profiles.component').then(
            (c) => c.PortfoAllProfilesComponent,
          ),
      },
      {
        path: CASHOUT_ROUTE,
        loadComponent: () => import('./features/portfo/container/cash-out/cash-out.component').then((c) => c.CashOutComponent),
      },
      {
        path: CASHIN_ROUTE,
        loadComponent: () => import('./features/portfo/container/cash-in/cash-in.component').then((c) => c.CashInComponent),
      },
      {
        path: WALLET_CASH_IN_INDISTINCTIVE_ROUTE + '/:id',
        loadComponent: () =>
          import('./features/wallet/containers/wallet-cash-in-indistinctive/wallet-cash-in-indistinctive.component').then(
            (c) => c.WalletCashInIndistinctiveComponent,
          ),
      },
      {
        path: CROWD_LIST_ROUTE,
        // canActivate: [StagingGuard],
        canActivateChild: [StagingGuard],
        children: [
          {
            path: ':id',
            loadComponent: () => import('./features/crowds/crowd-detail/crowd-detail.component').then((c) => c.CrowdDetailComponent),
          },
          {
            path: '',
            loadComponent: () => import('./features/crowds/crowd-list/crowd-list.component').then((c) => c.CrowdListComponent),
          },
        ],
      },
      {
        path: IPO_ROUTE + '/:id',
        loadComponent: () => import('./features/ipo/ipo.component').then((c) => c.IPOComponent),
      },
      {
        path: PAYMENT_METHOD_CONDITIONS_ROUTE + '/:symbol',
        loadComponent: () =>
          import('./features/choice-payment-way/components/payment-conditions/payment-conditions.component').then(
            (c) => c.PaymentConditionsComponent,
          ),
      },
      {
        path: CHOICE_PAYMENT_METHOD_ROUTE + '/:id',
        loadComponent: () => import('./features/choice-payment-way/choice-payment-way.component').then((c) => c.ChoicePaymentWayComponent),
      },
      {
        path: SELL_STOCK_ROUTE + '/:id',
        loadComponent: () => import('./features/sell-stock/sell-stock.component').then((c) => c.SellStockComponent),
      },
      {
        path: HOME_ROUTE,
        loadComponent: () => import('./features/home/home.component').then((c) => c.HomeComponent),
      },
      {
        path: HOME_TAB_ROUTE,
        loadComponent: () => import('./features/home/home.component').then((c) => c.HomeComponent),
      },
      {
        path: '**',
        redirectTo: HOME_ROUTE,
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '',
    redirectTo: HOME_ROUTE,
    pathMatch: 'full',
  },
];
